export default __webpack_public_path__ + "static/media/sa-dropdown.15f975eb.webp";